import { STORE_REF_ID_SEPARATOR } from '@/utils/constants'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export const goToStore = (
  router: AppRouterInstance,
  params?: {
    store: {
      code: string
      id: string
    }
    breakpoint: string
  }
) => {
  const url = `/store/${params?.store.code}${STORE_REF_ID_SEPARATOR}${params?.store.id}/${params?.breakpoint}`

  router.push(url)
}
